import ApiService from "../../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/partner/user/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    savePartnerUser: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/partner/user/edit/save", vo, successCallback, failureCallback);
    },
    createPartnerUser: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/partner/user/edit/create", vo, successCallback, failureCallback);
    },
    savePassword: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/partner/user/edit/savepassword", vo, successCallback, failureCallback);
    }
};

export default EditService;